export const getSearchBoxHeight = (searchResultsTotal: number, searchResultsSection: string, headersNm: number) =>
  !searchResultsTotal
    ? 110
    : searchResultsSection === ''
      ? 135 + searchResultsTotal * 30 + (headersNm - 1) * 50 > 514
        ? 514
        : 135 + (headersNm - 1) * 50 + searchResultsTotal * 30
      : 160 + searchResultsTotal * 30 > 476
        ? 476
        : 145 + searchResultsTotal * 30;
